<form [formGroup]="quoteSummaryForm">
  <amfam-quote-summary-header
    [quoteData]="quoteDataForHeaderPartners$ | async"
    [vehicleName]="vehicleRiskDescription$ | async"
  >
  </amfam-quote-summary-header>
  <h2
    dsContent
    class="pad-top-20 margin-bottom-20 row column twelve lg-push-two md-eight md-push-two quote-header"
  >
    <span class="icon-programs margin-right-10"></span>
    <span dsContent [contentPath]="'policy.addVehiclequoteSummaryHeader'"></span>
  </h2>
  <div class="pad-top-20 margin-bottom-20 row column twelve lg-push-two md-eight md-push-two">
    @if (
      (isPartner$ | async)
        ? (vehicleCoveragesSummaryListPartners$ | async)
        : (vehicleCoveragesSummaryList$ | async)
    ) {
      <div class="margin-bottom-50">
        <span class="icon-binoculars margin-right-10 bold-header"></span>
        <span
          dsContent
          class="bold-header"
          [contentPath]="'policy.addVehicleDeductibleHeader'"
          data-cy="addVehicleDeductibleHeader"
        ></span>
        <amfam-quote-summary
          [summaryList]="
            (isPartner$ | async)
              ? (vehicleCoveragesSummaryListPartners$ | async)
              : (vehicleCoveragesSummaryList$ | async)
          "
        >
        </amfam-quote-summary>
      </div>
    }
    @if (
      (isPartner$ | async)
        ? (policyCoveragesSummaryListPartners$ | async)
        : (policyCoveragesSummaryList$ | async)
    ) {
      <div class="margin-bottom-50">
        <span class="icon-claims margin-right-10 bold-header"></span>
        <span
          dsContent
          class="bold-header"
          [contentPath]="'policy.addVehicleIncludedCoverageHeader'"
        ></span>
        <amfam-quote-summary
          [summaryList]="
            (isPartner$ | async)
              ? (policyCoveragesSummaryListPartners$ | async)
              : (policyCoveragesSummaryList$ | async)
          "
        >
        </amfam-quote-summary>
      </div>
    }
    @if (
      (isPartner$ | async)
        ? (discountsOnCoveragesSummaryListPartners$ | async)
        : (discountsOnCoveragesSummaryList$ | async);
      as discounts
    ) {
      <div class="margin-bottom-50">
        <span class="icon-complete-circle margin-right-10 bold-header"></span>
        <span
          dsContent
          class="bold-header"
          [contentPath]="'policy.addVehicleDiscountsHeader'"
        ></span>
        <amfam-quote-summary [summaryList]="discounts"> </amfam-quote-summary>
      </div>
    }

    <blockquote class="border -primary-800 caption">
      @if (hasAntiTheftDiscount$ | async) {
        <div
          dsContent
          [contentPath]="'policy.antiTheftDiscountDisclaimer'"
          class="margin-bottom-10"
        ></div>
      }
      <div dsContent [contentPath]="'policy.addVehicleDisclaimer1'"></div>
      <br />
      <div
        dsContent
        [contentPath]="
          (isPartner$ | async)
            ? 'policy.addVehiclePartnerDisclaimer2'
            : 'policy.addVehicleDisclaimer2'
        "
      ></div>
    </blockquote>
  </div>

  <div class="column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      [displayBackButton]="true"
      [tertiaryButtonName]="'Cancel'"
      [primaryButtonName]="'Add Vehicle'"
      (primaryEvent)="onlineBind()"
      [secondaryButtonName]="(isPartner$ | async) ? 'Send to an advisor' : 'send to my agent'"
      (secondaryEvent)="notifyAgentEvent.emit({ isProcessExited: true })"
      [disableSecondaryButton]="(authorized$ | async) !== true"
      (tertiaryEvent)="cancelEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</form>

<ds-agent-selection-modal
  [agentSelectionModalId]="agentSelectionModalId"
  [agents]="agents$ | async"
  (confirmAgentSelection)="agentConfirmationFromModal($event)"
  (agentCancel)="cancelEventFromAgentSelectionModal()"
>
</ds-agent-selection-modal>
